import { useCallback, useEffect, useState } from 'react'
import type {
  AccountDoc,
  UsageDoc
} from '@smorgrav/hundehall_shared'
import { apiFetch } from '@/api'

interface CustomerOverview {
  site: { id: string; name: string }
  account: AccountDoc | null
  currentUsage: UsageDoc | null
  previousUsage: UsageDoc | null
}

const useCustomerOverviews = () => {
  const [overviews, setOverviews] = useState<CustomerOverview[]>([])
  const [loading, setLoading] = useState(true)

  const refetch = useCallback(async () => {
    setLoading(true)
    try {
      const res = await apiFetch('/admin/customers')
      if (!res.ok) {
        const body = await res.text().catch(() => '')
        throw new Error(`HTTP ${res.status}: ${body}`)
      }
      const json = (await res.json()) as { overviews: CustomerOverview[] }
      setOverviews(json.overviews)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    refetch().catch((err) =>
      console.error('Failed to fetch customer overviews', err)
    )
  }, [refetch])

  return { overviews, loading, refetch }
}

export { useCustomerOverviews }
export type { CustomerOverview }
